/**
 * @generated SignedSource<<d8e16862a9550da2a9b838a39d72b480>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedTrackingContainer_user$data = {
  readonly serviceId: string | null;
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentType": "SharedTrackingContainer_user";
};
export type SharedTrackingContainer_user$key = {
  readonly " $data"?: SharedTrackingContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedTrackingContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedTrackingContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d2801a05d6c3b022ead4351dee42082d";

export default node;
